export const between = (n, { min, max }) => {
  return min < max ? n >= min && n <= max : n >= max && n <= min;
};
